<template>
  <SPCoreShell class="h-100">
    <template #filter>
      <v-select class="my-4" v-model="liveFilters.pharmacy" :items="filterListData.pharmacyList" item-text="name" item-value="id" label="Pharmacy" multiple outline hide-details />
      <v-select class="mb-4" v-model="liveFilters.month" :items="filterListData.monthList" item-text="name" item-value="value" label="Month" outline hide-details />
    </template>
    <div class="hvh-flex column w-100">
      <div class="hvh-flex center align-center w-100 mt-4 mb-3">
        <v-icon class="mr-2" :class="{ disabled: liveFilters.month <= startDate }" @click="addMonth(-1)">mdi-chevron-left</v-icon>
        <p class="date spcore-big-text m-0">{{ liveFilters.month.format('MMMM YYYY') }}</p>
        <v-icon class="ml-2" :class="{ disabled: liveFilters.month >= endDate }" @click="addMonth(1)">mdi-chevron-right</v-icon>
      </div>
      <div class="hvh-flex w-100 grow-1 box pt-4">
        <div class="col-4 pl-4 pr-3">
          <div class="text-center">
            <p class="spcore-big-text mb-2">Overall Data Score</p>
            <SPCorePercentageSchell class="spcore-big-text mb-4" :value="95" />
          </div>
          <table class="overall-table w-100">
            <tbody>
              <tr v-for="(row, ind) in overallData" :key="ind">
                <td class="bold">{{ row[0] }}</td>
                <td>
                  <div class="hvh-flex"><SPCorePercentageCircle class="mr-2" :value="row[1]" />{{ row[1] }}%</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-8 pl-3 pr-4">
          <SPCoreCalendar class="w-100" :value="liveFilters.month">
            <template slot-scope="{ item, index }">
              <div class="date-box p-3" :class="{ 'red-background': getValue(item) < 20, selected: isDateSelected(item), clickable: item }" @click="selectedDate = item" v-if="item">
                <div class="date-index">{{ twoDigits(index + 1) }}</div>
                <SPCorePercentageCircle class="calendar-circle" :value="getValue(item)" />
              </div>
            </template>
          </SPCoreCalendar>
        </div>
      </div>
      <div class="grow-1 p-4" v-if="selectedDate">
        <div class="p-3">
          <div class="hvh-flex space-between align-baseline">
            <div class="spcore-big-text mb-3">{{ selectedDate.format('MMMM DD, YYYY') }}</div>
            <div>
              <v-btn flat block small class="hvh-btn hvh-btn--secondary no-radius">Export PPT</v-btn>
            </div>
          </div>
          <SPCoreDataEnablementDateBox class="mt-3" :value="item" v-for="(item, ind) in details" :key="ind" />
        </div>
      </div>
    </div>
  </SPCoreShell>
</template>
  
<script>
import SPCoreShell from '../../components/spcore/SPCoreShell.vue';
import SPCoreCalendar from '../../components/spcore/SPCoreCalendar.vue';
import moment from 'moment';
import SPCoreDataEnablementDateBox from '../../components/spcore/SPCoreDataEnablementDateBox.vue';
import SPCorePercentageCircle from '../../components/spcore/SPCorePercentageCircle.vue';
import SPCorePercentageSchell from '../../components/spcore/SPCorePercentageSchell.vue';
import details from './data/data-enablement-details.json';

export default {
  title: 'Data Enablement',
  components: { SPCoreShell, SPCoreCalendar, SPCoreDataEnablementDateBox, SPCorePercentageCircle, SPCorePercentageSchell },
  data() {
    var monthList = [];
    var startDate = moment('2010-01-01').endOf('month');
    var endDate = moment().endOf('month');
    for (var i = startDate; i <= endDate; i = i.clone().add(1, 'months')) {
      monthList.push({ name: i.format('MMMM YYYY'), value: i });
    }
    return {
      overallData: [
        ['Timeliness', 95],
        ['Completeness', 95],
        ['Accuracy', 100],
      ],
      calendarData: {},
      liveFilters: {
        month: moment(),
      },
      filterListData: {
        monthList: monthList.reverse(),
      },
      selectedDate: null,
      details,
    };
  },
  computed: {
    startDate() {
      return moment('2010-01-01').endOf('month');
    },
    endDate() {
      return moment().startOf('month');
    },
  },
  methods: {
    getValues() {
      // axios.get...
      var randObj = { 1: 50, 2: 100 };
      var getRandom = () => {
        var r = Math.ceil(Math.random() * 3);
        return randObj[r] || 0;
      };

      var from = this.liveFilters.month.clone().startOf('month');
      var to = this.liveFilters.month.clone().endOf('month');

      this.calendarData = {};
      for (var i = from; i <= to; i = i.clone().add(1, 'days')) {
        this.calendarData[i.format('YYYY-MM-DD')] = getRandom();
      }
    },
    getValue(date) {
      return this.calendarData[moment(date).format('YYYY-MM-DD')];
    },
    twoDigits(num) {
      return (num).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
    },
    addMonth(num) {
      this.liveFilters = {
        ...this.liveFilters,
        month: this.liveFilters.month.clone().add(num, 'months'),
      };
    },
    isDateSelected(date) {
      return this.selectedDate && date.format('YYYY-MM-DD') === this.selectedDate.format('YYYY-MM-DD');
    },
  },
  watch: {
    'liveFilters.month'() {
      this.getValues();
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisSPCoreDataEnablement'] = this;
    this.getValues();
  },
}
</script>

<style lang="scss" scoped>
.box {
  border-top: 1px solid #8ccac8;
  border-bottom: 1px solid #8ccac8;
  background-color: #f5fbfb;
}
.calendar-circle {
  width: 21px;
  height: 21px;
}
.date {
  min-width: 130px;
  text-align: center;
}
.date-index {
  position: absolute;
  top: 5px;
  left: 5px;
  font-size: 10px;
}

.overall-table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  color: #181815;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;

  td,
  th {
    border: 0px solid #ddd;
    padding: 8px;
  }

  tr:nth-child(odd) {
    background-color: rgba(140, 202, 200, 0.12);
  }

  tr:hover {
    background-color: #ddd;
  }

  th {
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: left;
    background-color: #8ccac840;
  }

  .circle {
    width: 20px;
    height: 20px;
  }
}

.red-background {
  background-color: rgba(229, 26, 44, 0.12);
}

.date-box {
  position: relative;
  text-align: center;
  border: 1px solid transparent;
  &.selected {
    border-color: #002f6c;
  }
}

.no-radius {
  border-radius: 0 !important;
}
</style>